import { useState, useEffect } from 'react';
import { isFunction } from 'lodash';
import cx from 'classnames';

import CheckedIcon from 'components/icons/CheckedIcon';
import CheckedMiddleIcon from 'components/icons/CheckedMiddleIcon';

import { StyledToggle, StyledCheckbox, StyledContent } from './checkbox.style';

type CheckboxTypeNames = 'default' | 'middle' | 'secondary';

type CheckboxProps = {
  type?: CheckboxTypeNames;
  className?: string;
  checked?: boolean;
  disabled?: boolean;
  onChange: (prop: boolean) => void;
};

const getComponentIcon = (type) => {
  switch (type) {
    case 'default':
      return <CheckedIcon color="#000" />;
    case 'middle':
      return <CheckedMiddleIcon color="#fff" />;
    case 'secondary':
      return <CheckedMiddleIcon color="#000" />;
  }
};

const Checkbox = ({
  type = 'default',
  className = 'custom-checkbox',
  disabled = false,
  checked = false,
  onChange = () => {},
  children
}: React.PropsWithChildren<CheckboxProps>) => {
  const [toggle, setToggle] = useState(checked);

  useEffect(() => {
    setToggle(checked);
  }, [checked]);

  const triggerToggle = () => {
    setToggle((prev) => !prev);

    if (isFunction(onChange)) {
      onChange(!toggle);
    }
  };

  return (
    <StyledToggle
      onClick={disabled ? undefined : triggerToggle}
      className={cx(className, type, {
        'toggle--checked': toggle,
        disabled
      })}
    >
      <StyledCheckbox type={type}>
        {toggle && getComponentIcon(type)}
      </StyledCheckbox>
      <StyledContent>{children}</StyledContent>
    </StyledToggle>
  );
};

export default Checkbox;
